import React from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "shards-react";

import { Dispatcher, Constants } from "../../../flux";

class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  handleToggleSidebar() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR
    });
  }

  render() {
    const { hideLogoText } = this.props;
    return (
      <div className="main-navbar">
        <Navbar
          className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
          type="light"
        >
          <NavbarBrand
            // className="w-100 mr-0"
            href="#"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 0"
            }}
          >
            <div
              // className="d-table m-auto"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",  
              }}
            >
              <img
                id="main-logo"
                // className="d-inline-block align-center mr-1"
                style={{
                  maxWidth: "140px",
                  // width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  display: "block",
                  padding: "1rem"
                }}
                // src="https://www.coredata.co.in/images/logowithtag.png"
                src="/Agrim.png"
                alt="Shards Dashboard"
              />
              {!hideLogoText && (
                <span
                  style={{
                    marginLeft: "8px",
                    display: "none" // keep hidden unless you add text later
                  }}
                  className=" d-md-inline "
                ></span>
              )}
            </div>
          </NavbarBrand>

          {/* eslint-disable-next-line */}
          <a
            className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
            onClick={this.handleToggleSidebar}
          >
            <i className="material-icons">&#xE5C4;</i>
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false
};

export default SidebarMainNavbar;
